export const NAME = 'CONTROL_POINT_DYNAMIC_PORTAL';